// start:ng42.barrel
import './transport-method-add.component';
import './transport-method-edit.component';
import './transport-methods.component';
// end:ng42.barrel

